export const ACTIVATION_DATE_FORMAT = 'MMM DD, YYYY hh:mm a';
